<template>
    <v-container>
      <div class="esign-backbar">
        <v-btn text class="esign-back-btn" @click="back()">
          <v-icon left>mdi-arrow-left</v-icon> Kembali
        </v-btn>
      </div>
      <div class="mb-5">
        <material-card color="primary" title="Detail Pengguna" class="card-wrapper">
          <v-form>
            <v-row>
              <v-col cols="12" md="6">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Username</p>
                  <v-text-field
                    dense
                    hide-details 
                    placeholder="Username" 
                    readonly
                    outlined
                    v-model="formData.username"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Nama Lengkap</p>
                  <v-text-field
                    dense
                    hide-details 
                    placeholder="Nama Lengkap"
                    readonly
                    outlined
                    v-model="formData.nama_lengkap"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">NIK</p>
                  <v-text-field
                    dense
                    hide-details 
                    placeholder="NIK" 
                    outlined
                    readonly
                    v-model="formData.nik"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Jabatan</p>
                  <v-text-field
                    dense
                    hide-details 
                    placeholder="Jabatan"
                    outlined
                    readonly
                    v-model="formData.jabatan"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Email</p>
                  <v-text-field
                    dense
                    hide-details 
                    placeholder="Email" 
                    readonly
                    outlined
                    v-model="formData.email"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Organisasi (PAU/Fakultas/Sekolah)</p>
                  <v-text-field
                    dense
                    hide-details 
                    placeholder="Organisasi (PAU/Fakultas/Sekolah)"
                    outlined
                    readonly
                    v-model="organisasi"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Status BSRE</p>
                  <v-text-field
                    dense
                    hide-details 
                    placeholder="Status BSRE" 
                    readonly
                    outlined
                    v-model="status_bsre"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">File Tanda Tangan</p>
                  <p v-if="this.formData.file_ttd == '' " class="label">Pengguna ini tidak memiliki File Tanda Tangan</p>
                  <a v-if="this.formData.file_ttd !== '' " v-bind:href="filettdimg" v-bind:download="formData.file_ttd"> {{ this.formData.file_ttd }}</a> &nbsp;
                  <v-btn v-if="this.formData.file_ttd !== '' " small color="primary" dark @click="showFileTtd()">Lihat Gambar</v-btn>&nbsp;
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">File Paraf</p>
                  <p v-if="this.formData.file_paraf == '' " class="label">Pengguna ini tidak memiliki File Paraf</p>
                  <a v-if="this.formData.file_paraf !== '' " v-bind:href="fileparafimg" v-bind:download="formData.file_paraf"> {{ this.formData.file_paraf }}</a> &nbsp;
                  <v-btn v-if="this.formData.file_paraf !== '' " small color="primary" dark @click="showFileParaf()">Lihat Gambar</v-btn>&nbsp;
                </div>
              </v-col>
              <v-col cols="12" md="2">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Status</p>
                  <v-checkbox v-model="formData.status" 
                    v-if="formData.status === true" label="Aktif" 
                    readonly
                    outlined 
                    class="primary--text"/> 
                  <v-checkbox v-model="formData.status" 
                    v-else-if="formData.status === false" label="Tidak Aktif" 
                    readonly
                    outlined 
                    class="primary--text"/>
                </div>
              </v-col>
              <p style="color:red;">{{errorMessageNama}}</p>
              <!-- <v-col cols="12" class="text-right">
                <v-btn color="gray" dark @click="cancel()">Batal</v-btn>&nbsp;
                <v-btn color="primary" dark @click="postData()">Simpan</v-btn>&nbsp;
              </v-col> -->
            </v-row>
          </v-form>

          <v-card
            elevation="2"
            outlined
            tile
              >
              <v-card-title>
                Peran
              </v-card-title>
              <v-container>
                <v-row v-if="currentPeran ==='A01'">

                    <v-col
                    cols="12"
                    sm="0"
                    md="4"
                    >Daftar Peran
                    </v-col>

                    <v-col
                    cols="12"
                    sm="6"
                    md="10"
                    >
                    <v-select
                      :items="addablePeran"
                      :item-text="item => item.nama"
                      :item-value="item => item.id"
                      placeholder="Pilih Peran"
                      v-model="selectedPeran"
                      no-data-text="Pengguna memiliki semua peran"
                      clearable
                      dense
                      outlined
                      :loading="loading"
                      @keydown.enter.prevent
                    >
                    </v-select>
                    </v-col>

                    <v-col
                    cols="12"
                    sm="6"
                    md="2"
                    >
                    <v-btn color="primary" dark @click="addPeranToPengguna">Tambah</v-btn>
                    </v-col>
                </v-row>
                <v-simple-table>
                    <template v-slot:default>
                    <thead>
                        <tr>
                        <th class="text-left">
                            No
                        </th>
                        <th class="text-left">
                            Nama Peran
                        </th>
                        <th v-if="currentPeran ==='A01'" class="text-left">
                            Aksi
                        </th>
                        </tr>
                    </thead>
                    <tbody>
                        <p class="pl-4 pt-4" v-if="appliedPeran.length === 0">Pengguna tidak memiliki peran apapun</p>
                        <tr
                        v-for="(peran, key) in appliedPeran"
                        >
                        <td>{{ key + 1 }}</td>
                        <td>{{ peran.nama }}</td>
                        <td v-if="currentPeran ==='A01'">
                          <v-btn
                            color="red"
                            class="mr-4 white--text"
                            @click="removePeranDialogue(peran)"
                          >
                            Hapus
                          </v-btn>
                        </td>
                        </tr>
                    </tbody>
                    </template>
                </v-simple-table>
                <!-- <v-checkbox v-if="tambah || ubah" label="Saya telah mengkonfirmasi posisi tanda tangan dan kesesuaian dokumen di atas" v-model="showSimpan"></v-checkbox> -->
              </v-container>
            </v-card>
            <v-dialog v-model="dialog" max-height="800px" max-width="800px">
              <v-card class="card-modal" style="box-shadow:none!important;">
                <v-toolbar
                  dark
                  color="primary"
                >
                  <v-toolbar-title>{{ titledialog }}</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-toolbar-items>
                    <v-btn
                      icon
                      dark
                      @click="close()"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar-items>
                </v-toolbar>
                <div class="text-center mt-6 mb-6">
                  <img v-if="dialogttd" :src="filettdimg" alt="File Tanda Tangan" width="80%">
                  <img v-if="dialogparaf" :src="fileparafimg" alt="File Paraf" width="80%">
                </div>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialogremoveperan" max-width="500px">
              <v-card class="card-modal">
                <v-card-title>
                  <span class="headline">Hapus Peran {{ deletePeran.nama }}</span>
                </v-card-title>
      
                <v-card-text>
                  Apakah anda yakin ingin menghapus Peran {{ deletePeran.nama }} dari pengguna {{ formData.username }} ?
                </v-card-text>
      
                <v-card-actions>
                  <div class="flex-grow-1"></div>
                  <v-btn @click="close()">Batal</v-btn>
                  <v-btn color="primary" dark @click="removePeranFromPengguna()">Hapus</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="5000" :top="true">
              {{ snackbarText }}
              <v-btn dark text @click="snackbar = false">Tutup</v-btn>
            </v-snackbar>
            <v-col cols="12" class="text-right">
              <v-btn v-if="currentPeran ==='A01'" color="orange" dark @click="editItem()">Ubah</v-btn>&nbsp
            </v-col>
        </material-card>
      </div>

    </v-container>
  </template>
  
<script>
  import { apiServer } from "../../setup-axios";
  export default {
    data: () => ({
      successCreate: null,
      errorMessageNama: null,
      filettdimg: "",
      fileparafimg: "",
      titledialog:"",
      dialog:false,
      dialogremoveperan: false,
      dialogttd: false,
      dialogparaf: false,
      snackbar:false,
      snackbarColor:"",
      snackbarText:"",
      selectedPeran: null,
      peranpenggunas: [],
      allPeran: [],
      organisasi: "",
      deletePeran: {},
      currentPeran: "",
      status_bsre:"",
      formData: {
        id:"",
        nama_lengkap:"",
        username:"",
        file_ttd:"",
        file_paraf:"",
        jabatan:"",
        nik:"",
        email:"",
        status: true,
        id_organisasi:"",
        sumber:"",
      },
    }),
    mounted() {
      console.log("loading")
      this.getData();
      this.getListPeran();
      this.fetchImages();
    },
    computed: {
      appliedPeran(){
        return this.allPeran.filter(
          applied => this.peranpenggunas.some(existing => existing.id === applied.id) )
      },
      addablePeran(){
        return this.allPeran.filter(
          addable => !this.peranpenggunas.some(existing => existing.id === addable.id) )
      }
    },
    methods: {
      getData() {
        console.log("get data " + this.$route.params.id)
        apiServer
          .get("/pengguna/detail/id/" + this.$route.params.id)
          .then(response => {
            console.log(response.data.data)
            this.formData = response.data.data.pengguna;
            this.formData.id_organisasi = response.data.data.pengguna.id_organisasi
            this.peranpenggunas = response.data.data.listperan;
            this.currentPeran = localStorage.getItem("currentPeran")
            this.status_bsre = JSON.parse(response.data.data.status_bsre).message;
            console.log(this.formData)
            console.log(this.peranpenggunas)
            this.getOrganisasi()
          })
          .catch(error => {
            console.log("There was an error:", error.response); // Logs out the error
          });
      },
      getOrganisasi(){
        console.log("get organisasi " + this.formData.id_organisasi)
        apiServer
          .get("/organisasi/id/" + this.formData.id_organisasi)
          .then(response => {
            console.log(response.data.data)
            this.organisasi = response.data.data.nama;
            console.log(this.organisasi)
          })
          .catch(error => {
            console.log("There was an error:", error.response); // Logs out the error
          });
      },
      getListPeran(){
        console.log("get all peran")
        apiServer
          .get("/peran/all")
          .then(response => {
            console.log(response.data.data)
            this.allPeran = response.data.data
            console.log(this.allPeran)
          })
          .catch(error => {
            console.log("There was an error:", error.response); // Logs out the error
          });
      },
      addPeranToPengguna(){
        if (this.selectedPeran === null) {
          this.showSnackbar("error", "Anda belum memilih peran untuk ditambahkan")
          return
        }
        console.log("add peran " + this.selectedPeran + " to pengguna " + this.formData.username)
        let peranData = new FormData()
        peranData.append("IdPengguna",this.formData.id)
        peranData.append("IdPeran",this.selectedPeran)
        console.log(peranData)
        apiServer
          .post("/peran/add", peranData)
          .then(response => {
            this.peranpenggunas = response.data.data
            console.log(this.peranpenggunas)
            this.showSnackbar("primary","Peran berhasil ditambahkan ke Pengguna " + this.formData.username)
            this.selectedPeran = null
          })
          .catch(error => {
            console.log("There was an error:", error.response); // Logs out the 
            this.showSnackbar("error", error.response.data.message)
          });
      },
      removePeranDialogue(peran) {
        console.log("remove peran " + peran.nama)  
        this.deletePeran = peran
        this.dialogremoveperan = true;
      },
      removePeranFromPengguna(){
        console.log("remove peran " + this.deletePeran.nama + " from pengguna " + this.formData.username)
        apiServer
          .delete("/peran/remove", { 
              params: {
                IdPengguna: this.formData.id,
                IdPeran: this.deletePeran.id
              }})
          .then(response => {
            this.peranpenggunas = response.data.data
            console.log(this.peranpenggunas)
            this.showSnackbar("orange","Peran berhasil dihapus dari Pengguna " + this.formData.username)
            this.close()
          })
          .catch(error => {
            console.log("There was an error:", error.response); // Logs out the error
            this.showSnackbar("error", error.response.data.message)
          });
      },
      fetchImages() {
        console.log("fetch pengguna images")
        var timestamp = new Date().getTime() // get current timestamp
        apiServer
          .get("/pengguna/id/" + this.$route.params.id + "/getfilettd?timestamp="  + timestamp,{ responseType: 'blob' })
          .then(response => {
            this.filettdimg = URL.createObjectURL(response.data)
          })
        apiServer
          .get("/pengguna/id/" + this.$route.params.id + "/getfileparaf?timestamp="  + timestamp,{ responseType: 'blob' })
          .then(response => {
            this.fileparafimg = URL.createObjectURL(response.data)
          })
      },
      showFileTtd() {
        this.close()
        // this.fetchImages()
        console.log("show image " +this.formData.file_ttd)        
        this.dialogttd = true;
        this.titledialog = "File Tanda Tangan";
        this.dialog = true;
      },
      showFileParaf() {
        this.close()
        // this.fetchImages()
        console.log("show image " +this.formData.file_paraf)        
        this.dialogparaf = true;
        this.titledialog = "File Paraf";
        this.dialog = true;
      },
      editItem(){
        console.log()
        this.$router.push('/pengguna/ubah/' + this.formData.id);
      },
      back() {
        this.$router.push('/pengguna')
      },
      showSnackbar(color, message) {
        console.log("snack " + color + " - " + message);
        this.snackbar = true;
        this.snackbarText = message;
        this.snackbarColor = color;
      },
      close() {
        this.dialogremoveperan = false;
        this.dialogttd = false;
        this.dialogparaf = false;
        this.titledialog = "";
        this.dialog = false;
      },
      back() {
        this.$router.push('/pengguna')
      }
    }
  }
</script>
  